import { create, show, useModal } from "@ebay/nice-modal-react";
import { useCallback, useState } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import Button from "ds/components/Button";
import FormField from "ds/components/Form/Field";
import ModalCancelButton from "ds/components/Modal/CancelButton";
import ModalContent from "ds/components/Modal/Content";
import ModalFooter from "ds/components/Modal/Footer";
import ModalHeader from "ds/components/Modal/Header";
import ModalSimple from "ds/components/ModalSimple";
import Textarea from "ds/components/Textarea";
import useTypedContext from "hooks/useTypedContext";
import useLockStack from "shared/Stack/useLockStack";

type StackLockNoteModalProps = {
  stackId: string;
};

const StackLockNoteModal = create(function StackLockNoteModal({
  stackId,
}: StackLockNoteModalProps) {
  const modal = useModal();

  const [notes, setNotes] = useState("");

  const { reportSuccess } = useTypedContext(FlashContext);

  const [stackLock, { loading }] = useLockStack({
    refetchQueries: ["GetStack"],
  });

  const handleLock = useCallback(
    (note: string | null) => {
      stackLock({ id: stackId, note: note }, (data) => {
        if (data?.stackLock) {
          reportSuccess({ message: "Stack successfully locked" });
          modal.hide();
        }
      });
    },
    [modal, reportSuccess, stackId, stackLock]
  );

  return (
    <ModalSimple>
      <ModalHeader title="Lock stack" />

      <ModalContent>
        <FormField label="Note" isOptional id="lockNote">
          {({ ariaInputProps }) => (
            <Textarea
              name="lockNote"
              onChange={(e) => setNotes(e.target.value)}
              value={notes}
              minRows={3}
              maxRows={10}
              autoFocus
              placeholder="Enter the lock stack note here..."
              {...ariaInputProps}
            />
          )}
        </FormField>
      </ModalContent>
      <ModalFooter>
        <ModalCancelButton onClick={modal.hide} />
        <Button
          onPress={() => handleLock(notes)}
          variant="primary"
          loading={loading}
          disabled={loading}
        >
          Lock stack
        </Button>
      </ModalFooter>
    </ModalSimple>
  );
});

export const showStackLockNoteModal = (props: StackLockNoteModalProps) =>
  show(StackLockNoteModal, props);
